const TOKEN_NAME_ADMIN = 'token-admin';
const TOKEN_NAME_APP = 'token-app';

const getTokenName = (isAdmin) => (isAdmin ? TOKEN_NAME_ADMIN : TOKEN_NAME_APP);

const getToken = (isAdmin) => localStorage.getItem(getTokenName(isAdmin));

const removeToken = (isAdmin) => localStorage.removeItem(getTokenName(isAdmin));

const setToken = (value, isAdmin) => localStorage.setItem(getTokenName(isAdmin), value);

export {
  getToken,
  removeToken,
  setToken,
};
